import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="px-4 md:px-6 py-14">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
            <div className="md:col-span-2">
              <Link to="/" className="flex items-center gap-2.5 mb-4">
                <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                  <i className="ri-film-line text-lg text-background-50"></i>
                </div>
                <span className="font-heading text-lg font-semibold text-background-50">
                  里番文化研究所
                </span>
              </Link>
              <p className="text-background-400 text-sm leading-relaxed max-w-sm">
                致力于日本里番动画文化的学术研究与知识传播，为成年用户提供客观、理性、全面的里番文化资讯与深度分析内容。
              </p>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">快速导航</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/" className="text-background-400 hover:text-background-200 text-sm transition-colors">首页</Link>
                <Link to="/categories" className="text-background-400 hover:text-background-200 text-sm transition-colors">分类浏览</Link>
                <Link to="/about" className="text-background-400 hover:text-background-200 text-sm transition-colors">关于我们</Link>
              </div>
            </div>

            <div>
              <h4 className="font-heading font-semibold text-background-50 mb-4 text-sm">热门分类</h4>
              <div className="flex flex-col gap-2.5">
                <Link to="/categories/lishi-qiyuan" className="text-background-400 hover:text-background-200 text-sm transition-colors">历史起源</Link>
                <Link to="/categories/leixing-fenlei" className="text-background-400 hover:text-background-200 text-sm transition-colors">类型分类</Link>
                <Link to="/categories/guankan-xuzhi" className="text-background-400 hover:text-background-200 text-sm transition-colors">观看须知</Link>
              </div>
            </div>
          </div>

          <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-background-500 text-xs">
              &copy; {new Date().getFullYear()} 里番文化研究所. 本站内容仅供成年用户学术研究与文化了解之用.
            </p>
            <div className="flex items-center gap-5">
              <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors" rel="nofollow">隐私政策</a>
              <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors" rel="nofollow">使用条款</a>
              <a href="#" className="text-background-500 hover:text-background-300 text-xs transition-colors" rel="nofollow">联系我们</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}